module.exports = __webpack_public_path__ + "img/xmas_wrap.c78ba9cc.png";